module.exports = __webpack_public_path__ + "static/media/3.e82d770e.JPG";